module.exports = __webpack_public_path__ + "img/stop.4759aeb.svg";